import {
  UPDATE_LAYOUT_HEIGHTS,
  SET_LAYOUT_WITH_PROMPT,
  LayoutState,
  LayoutActionTypes,
} from "./layout.types";

const updateLayoutHeight = (
  field: Partial<LayoutState>
): LayoutActionTypes => ({
  type: UPDATE_LAYOUT_HEIGHTS,
  payload: field,
});

export const setHeaderHeight = (headerHeight: number): LayoutActionTypes =>
  updateLayoutHeight({ headerHeight });

export const setFooterHeight = (footerHeight: number): LayoutActionTypes =>
  updateLayoutHeight({ footerHeight });

export const setPrimaryNavigationHeight = (
  primaryNavigationHeight: number
): LayoutActionTypes => updateLayoutHeight({ primaryNavigationHeight });

export const setStaticNotificationHeight = (
  staticNotificationHeight: number
): LayoutActionTypes => updateLayoutHeight({ staticNotificationHeight });

export const setEulaHeaderHeight = (
  eulaHeaderHeight: number
): LayoutActionTypes => updateLayoutHeight({ eulaHeaderHeight });

export const setEulaFooterHeight = (
  eulaFooterHeight: number
): LayoutActionTypes => updateLayoutHeight({ eulaFooterHeight });

export const setLayoutWithPrompt = (
  isWithPrompt: boolean
): LayoutActionTypes => ({
  type: SET_LAYOUT_WITH_PROMPT,
  payload: isWithPrompt,
});
